import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './products-basket.component'

let module = angular.module('productsBasket', [
  uiRouter
])

.component('productsBasket', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/products-basket/index.js